import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { H1, StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import rewardPng from '/img/rewardsModal/reward.png';
import rewardWebp from '/img/rewardsModal/reward.webp';

const DailyRewardTitle: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Picture
        alt="reward"
        img={rewardPng}
        webp={rewardWebp}
        className="h-[9.5rem] -mb-6 [&>img]:w-auto"
      />
      <H1 className="mt-2" weight={'bold'}>
        {t('Reward Track')}
      </H1>
      <StringSmall className="mt-2 !text-white/60 text-center">
        {t('Loot’s ready — or soon will be. Watch the timer!')}
      </StringSmall>
    </>
  );
};

export default DailyRewardTitle;
